var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48096 8V17.0666C1.61558 18.7999 1.75019 21.0666 1.88481 22.6666C2.01942 24.5333 3.63481 26 5.51943 26H15.4809C17.3655 26 18.981 24.5333 19.1156 22.6666C19.2501 21.0666 19.3848 18.7999 19.5195 17.0666C19.654 15.0666 19.5195 10.9333 19.5195 8H1.48096Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9231 3.99999H16.5577L15.4808 2C14.8078 0.800006 13.5962 0 12.25 0H9.01924C7.67307 0 6.32692 0.800006 5.78847 2L4.44231 3.99999H1.07692C0.538466 3.99999 0 4.53333 0 5.06667C0 5.59999 0.538466 6.13333 1.07692 6.13333H19.9231C20.4615 6.13333 21 5.73333 21 5.06667C21 4.4 20.4615 3.99999 19.9231 3.99999ZM6.73078 3.99999L7.40385 2.93333C7.67307 2.39999 8.21153 2 8.88458 2H12.1154C12.7885 2 13.3269 2.26666 13.5962 2.93333L14.2692 3.99999H6.73078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashWhite);
export default __webpack_public_path__ + "static/media/trash-white.ebf7a12a394fa91a4c9e71e17e17ab8d.svg";
export { ForwardRef as ReactComponent };